import {createSlice} from "@reduxjs/toolkit";

const initialScholarJobInfosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  scholarJobInfoForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const scholarJobInfosSlice = createSlice({
  name: "scholarJobInfos",
  initialState: initialScholarJobInfosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getScholarJobInfoById
    scholarJobInfoFetched: (state, action) => {
      state.actionsLoading = false;
      state.scholarJobInfoForEdit = action.payload.scholarJobInfoForEdit;
      state.error = null;
    },
    // findScholarJobInfos
    scholarJobInfosFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createScholarJobInfo
    scholarJobInfoCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.scholarJobInfo);
    },
    // updateScholarJobInfo
    scholarJobInfoUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schJobInfoId === action.payload.scholarJobInfo.schJobInfoId) {
          return action.payload.scholarJobInfo;
        }
        return entity;
      });
    },
    // deleteScholarJobInfo
    scholarJobInfoDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schJobInfoId !== action.payload.schJobInfoId);
    },
    // deleteScholarJobInfos
    scholarJobInfosDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schJobInfoId)
      );
    },
  }
});
